/* Architect style product page: gallery, variant picker, quantity and add to cart */
(function () {
  function money(cents, fmt) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    fmt = fmt || '${{amount}}';
    function delim(n, prec, thou, dec) {
      if (isNaN(n) || n === null) return '0';
      var s = (n / 100).toFixed(prec).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thou || ',')) + (s[1] ? (dec || '.') + s[1] : '');
    }
    var m = fmt.match(re), key = m ? m[1] : 'amount', v;
    if (key === 'amount_no_decimals') v = delim(cents, 0);
    else if (key === 'amount_with_comma_separator') v = delim(cents, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') v = delim(cents, 0, '.', ',');
    else if (key === 'amount_with_apostrophe_separator') v = delim(cents, 2, "'", '.');
    else v = delim(cents, 2);
    return fmt.replace(re, v);
  }

  function json(root, sel, fallback) {
    var el = root.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : fallback; } catch (e) { return fallback; }
  }

  function init(root) {
    if (root.__axReady) return;
    root.__axReady = true;
    var variants = json(root, '[data-ax-variants]', []);
    var fmt = json(root, '[data-ax-money]', '${{amount}}');
    var labels = json(root, '[data-ax-labels]', { add: 'Add to cart', soldout: 'Sold out', unavailable: 'Unavailable' });
    var slider = root.querySelector('[data-ax-slider]');
    var slides = slider ? [].slice.call(slider.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-ax-goto]'));
    var tlist = root.querySelector('[data-ax-tlist]');

    function setActive(i) {
      thumbs.forEach(function (t, k) {
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var t = thumbs[i];
      if (t && tlist) {
        var li = t.parentElement, l = li.offsetLeft - tlist.offsetLeft;
        if (l < tlist.scrollLeft || l + li.offsetWidth > tlist.scrollLeft + tlist.clientWidth) tlist.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    function goTo(i, instant) {
      if (!slider || !slides[i]) return;
      slider.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    function mediaIndex(v) {
      if (!v || !v.featured_media) return -1;
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(v.featured_media.id)) return i;
      return -1;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    [].forEach.call(root.querySelectorAll('[data-ax-scroll]'), function (b) {
      b.addEventListener('click', function () {
        if (tlist) tlist.scrollBy({ left: Number(b.getAttribute('data-ax-scroll')) * tlist.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    if (slider) {
      var timer;
      slider.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { setActive(Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth))); }, 90);
      }, { passive: true });
    }

    var form = root.querySelector('[data-ax-form]');
    var idInput = root.querySelector('[data-ax-id]');
    var atc = root.querySelector('[data-ax-atc]');
    var atcLabel = root.querySelector('[data-ax-atc-label]');
    var atcPrice = root.querySelector('[data-ax-atc-price]');
    var priceBox = root.querySelector('[data-ax-price]');
    var groups = [].slice.call(root.querySelectorAll('[data-ax-option]'));

    function selected() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function priceHTML(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<span class="ax-pp__sale">' + money(v.price, fmt) + '</span><s class="ax-pp__compare">' + money(v.compare_at_price, fmt) + '</s>';
      }
      return '<span class="ax-pp__regular">' + money(v.price, fmt) + '</span>';
    }
    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        [].forEach.call(g.querySelectorAll('input'), function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var v = find(test), lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selected(), v = find(opts);
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked'), out = g.querySelector('[data-ax-value]');
        if (c && out) out.textContent = c.value;
      });
      markAvailability(opts);
      if (idInput) idInput.value = v ? v.id : '';
      if (priceBox && v) priceBox.innerHTML = priceHTML(v);
      if (atc) {
        atc.disabled = !v || !v.available;
        if (atcLabel) atcLabel.textContent = !v ? labels.unavailable : (v.available ? labels.add : labels.soldout);
        if (atcPrice) atcPrice.textContent = v ? money(v.price, fmt) : '';
      }
      if (v) {
        var url = root.getAttribute('data-url');
        if (url && location.pathname === url && window.history && history.replaceState) { var variantUrl = new URL(window.location.href); variantUrl.searchParams.set('variant', v.id); history.replaceState(history.state, '', variantUrl.toString()); }
        var mi = mediaIndex(v);
        if (mi > -1) goTo(mi);
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });
    if (groups.length) markAvailability(selected());
    if (idInput) {
      var cur = null;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === idInput.value) cur = variants[i];
      var start = mediaIndex(cur);
      if (start > 0) goTo(start, true);
    }

    [].forEach.call(root.querySelectorAll('[data-ax-qty]'), function (b) {
      b.addEventListener('click', function () {
        var inp = b.parentElement.querySelector('input');
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.getAttribute('data-ax-qty')));
      });
    });

    if (form) {
      var submitting = false;
      form.addEventListener('submit', async function (e) {
        if (submitting) { e.preventDefault(); return; }
        var actions = window.Shopify && window.Shopify.actions;
        if (!actions || !actions.updateCart || !actions.openCart) return;
        var data = new FormData(form);
        var attributes = [];
        for (var entry of data.entries()) {
          var property = entry[0].match(/^properties\[(.+)\]$/);
          if (property) {
            if (entry[1] instanceof File) return;
            attributes.push({ key: property[1], value: String(entry[1]) });
          }
        }
        e.preventDefault();
        if (!form.reportValidity()) return;
        var line = { merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity') || 1) };
        if (attributes.length) line.attributes = attributes;
        if (data.get('selling_plan')) line.sellingPlanId = String(data.get('selling_plan'));
        var err = root.querySelector('[data-ax-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        submitting = true;
        if (atc) { atc.disabled = true; atc.setAttribute('aria-busy', 'true'); }
        var didAdd = false;
        try {
          var events = await import('@shopify/events');
          var pending = events.CartLinesUpdateEvent.createPromise();
          pending.promise.catch(function () {});
          root.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [line], promise: pending.promise }));
          var base = (window.Shopify.routes && window.Shopify.routes.root) || '/';
          var sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map(function (item) { return item.dataset.sectionId; }).filter(Boolean);
          if (sectionIds.length) data.set('sections', sectionIds.join(','));
          var response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          var added = await response.json();
          if (!response.ok || added.status) throw new Error(added.description || added.message || labels.error);
          didAdd = true;
          var cartResponse = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(labels.error);
          var cart = await cartResponse.json();
          pending.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: added.sections, source: 'ax-product', sourceId: form.id, itemCount: line.quantity, didError: false } });
          await actions.openCart();
        } catch (ex) {
          if (pending) pending.reject(ex);
          if (events) root.dispatchEvent(new events.CartErrorEvent({ error: ex.message || labels.error, code: didAdd ? 'SERVICE_UNAVAILABLE' : 'INVALID' }));
          if (didAdd) {
            window.location.href = root.getAttribute('data-cart') || '/cart';
            return;
          }
          if (err) { err.textContent = ex.message || labels.error; err.hidden = false; }
        } finally {
          submitting = false;
          if (atc) atc.removeAttribute('aria-busy');
          update();
        }
      });
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('.ax-pp'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();